import React from 'react';
import s from './ShadowBox.module.css';

const ShadowBox = ({ children }) => {
  return (
    <div className={s.shadowBox}>
      {children}
    </div>
  );
};

export default ShadowBox;
